import React, { useState } from "react";
import { Button, Grid } from "@material-ui/core";
import EmailIcon from "@material-ui/icons/Email";
import { UserListContext } from "../../../../../../context/follow-up-widgets";
import { isEmpty } from "lodash";
import EmailInputModal from "./email-input-modal";

const ResultsActionView = () => {
  const { results } = React.useContext(UserListContext);

  const [displayEmailInputModal, setDisplayEmailInputModal] = useState();

  return (
    !isEmpty(results) && (
      <Grid container justifyContent="flex-end">
        <Button
          variant="contained"
          size="small"
          startIcon={<EmailIcon />}
          className="export-email-button uppercase"
          onClick={() => setDisplayEmailInputModal(true)}
        >
          Export to Email
        </Button>
        {displayEmailInputModal && (
          <EmailInputModal
            showModal={displayEmailInputModal}
            closeModal={() => setDisplayEmailInputModal(false)}
          />
        )}
      </Grid>
    )
  );
};

export default ResultsActionView;
